// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"D7-z"};